export default __webpack_public_path__ + "static/media/libra.78962545.png";